import createIcon from '../../createIcon';

/**
 * @component @name KeyboardDoubleArrowDown
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggNi40MUwxNi41OSA1TDEyIDkuNThMNy40MSA1TDYgNi40MUwxMiAxMi40MUwxOCA2LjQxWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE4IDEzTDE2LjU5IDExLjU5TDEyIDE2LjE3TDcuNDEgMTEuNTlMNiAxM0wxMiAxOUwxOCAxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const KeyboardDoubleArrowDown = createIcon('KeyboardDoubleArrowDown', [
  ['path', { d: 'M18 6.41L16.59 5L12 9.58L7.41 5L6 6.41L12 12.41L18 6.41Z', key: '6p5plf' }],
  ['path', { d: 'M18 13L16.59 11.59L12 16.17L7.41 11.59L6 13L12 19L18 13Z', key: '93vvzt' }],
]);

export default KeyboardDoubleArrowDown;
